import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgWindows = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 27",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fill: "inherit",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "nonzero",
				d: "M27.333.25H11.75a2.833 2.833 0 0 0-2.833 2.833v12.75a2.833 2.833 0 0 0 2.833 2.834h15.583a2.842 2.842 0 0 0 2.834-2.834V3.083A2.833 2.833 0 0 0 27.333.25zm0 15.583H11.75V5.917h15.583v9.916z"
			}), /* @__PURE__ */ _jsx("path", { d: "M6.5 8.333V14H3.667v9.917H19.25v-2.834h2.833v2.667a3 3 0 0 1-3 3H3.833a3 3 0 0 1-3-3V11.333a3 3 0 0 1 3-3H6.5z" })]
		})
	})
});
export default SvgWindows;
